import { render } from "./About.vue?vue&type=template&id=f33be530"
const script = {}
script.render = render

export default script